// Import action types related to e-paper menu data
import {
  EPAPER_MENU_ARE_LOADING,
  EPAPER_MENU_HAVE_ERROR,
  EPAPER_MENU_FETCH_DATA_SUCCESS,
} from "../actionType";

// Define the initial state for the ePaperMenuReducer
const initialState = {
  data: [],
  loading: true,
  error: [], // Initialize error as null for better error handling
};

// Reducer function to handle e-paper menu-related actions and update state accordingly
export function ePaperMenuReducer(state = initialState, action) {
  switch (action.type) {
    // Handle error case when fetching e-paper menu data
    case EPAPER_MENU_HAVE_ERROR:
      return {
        ...state,
        error: action.hasError, // Update the error state with the error from the action
        loading: false, // Set loading to false since the request is complete
      };

    // Handle loading state when e-paper menu data is being fetched
    case EPAPER_MENU_ARE_LOADING:
      return {
        ...state,
        loading: action.isLoading, // Update the loading state with the loading status from the action
      };

    // Handle success case when e-paper menu data is successfully fetched
    case EPAPER_MENU_FETCH_DATA_SUCCESS:
      return {
        ...state,
        data: action.ePaperMenu, // Update the data state with the fetched e-paper menu data
        loading: false, // Set loading to false since the request is complete
        error: null, // Clear any previous errors
      };

    // Return the current state by default if action type is not recognized
    default:
      return state;
  }
}
